import { useState, useEffect } from "react";

// Banner cookie conforme (accetta / rifiuta / personalizza).
// TODO: I cookie non essenziali (analytics/marketing) vanno caricati SOLO dopo il consenso.
export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });

  useEffect(() => {
    if (!localStorage.getItem("mr_cookie_consent")) setOpen(true);
  }, []);

  const save = (consent) => {
    localStorage.setItem("mr_cookie_consent", JSON.stringify({ ...consent, essential: true, date: new Date().toISOString() }));
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[60] p-4 md:p-6">
      <div className="max-w-4xl mx-auto bg-white border border-brand-ivory rounded-2xl shadow-2xl p-5 md:p-6">
        <p className="text-sm text-brand-brown leading-relaxed">
          Utilizziamo cookie tecnici essenziali e, previo consenso, cookie di analisi e marketing per migliorare l’esperienza.
          Consulta la <a href="/cookie-policy" className="underline text-brand-olive">Cookie Policy</a>.
        </p>

        {custom && (
          <div className="mt-4 space-y-2 text-sm">
            <label className="flex items-center justify-between"><span>Cookie essenziali (sempre attivi)</span><input type="checkbox" checked disabled /></label>
            <label className="flex items-center justify-between"><span>Analisi</span><input type="checkbox" checked={prefs.analytics} onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} data-testid="cookie-analytics" /></label>
            <label className="flex items-center justify-between"><span>Marketing</span><input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} data-testid="cookie-marketing" /></label>
          </div>
        )}

        <div className="mt-5 flex flex-wrap gap-3">
          <button data-testid="cookie-accept" onClick={() => save({ analytics: true, marketing: true })} className="bg-brand-olive text-white hover:bg-brand-black transition-colors rounded-full px-6 py-2.5 text-sm font-medium">Accetta tutti</button>
          <button data-testid="cookie-reject" onClick={() => save({ analytics: false, marketing: false })} className="border border-brand-olive text-brand-olive hover:bg-brand-ivory transition-colors rounded-full px-6 py-2.5 text-sm font-medium">Rifiuta</button>
          {custom
            ? <button data-testid="cookie-save" onClick={() => save(prefs)} className="border border-brand-sage text-brand-brown rounded-full px-6 py-2.5 text-sm font-medium">Salva preferenze</button>
            : <button data-testid="cookie-customize" onClick={() => setCustom(true)} className="text-brand-brown underline text-sm px-2">Personalizza</button>}
        </div>
      </div>
    </div>
  );
}
